module.exports = __webpack_public_path__ + "static/media/googlePay.518bd2e0.png";